import React from "react";
import PropTypes from "prop-types";
import { Select } from "antd";
import { generateYearsArray, generateMonths } from "../../tools/dateTools";
import { useTranslation } from "react-i18next";
import Dropdown from "../Dropdown/Dropdown";
import moment from "moment";
import { DateOfBirthContainer } from "./DateOfBirthSelector.styles";
import useIsMobile from "../../hooks/useIsMobile";
import baseTheme from "../../config/baseTheme";
const { Option } = Select;

const DateOfBirthSelector = ({ value, onChange }) => {
    const { t } = useTranslation("shop");
    const isMobile = useIsMobile();
    const days = Array.from({ length: 31 }, (_, i) => i + 1);
    const months = generateMonths();
    const years = generateYearsArray(moment().year() - 14, 90);

    const handleDateChange = (key, fieldValue) => {
        onChange?.({ ...value, [key]: fieldValue });
    };

    return (
        <DateOfBirthContainer $isMobile={isMobile}>
            <Dropdown
                placeholder={t("dayUpperCase")}
                showSearch
                value={value?.day ?? undefined}
                onChange={(day) => handleDateChange("day", day)}
                size="large"
                style={{ borderRadius: "10px", borderColor: baseTheme.borders.gray }}
            >
                {days.map((day) => (
                    <Option key={day} value={day}>
                        {day}
                    </Option>
                ))}
            </Dropdown>

            <Dropdown
                placeholder={t("monthUperCase")}
                showSearch
                optionFilterProp="children"
                value={value?.month ?? undefined}
                onChange={(month) => handleDateChange("month", month)}
                style={{ borderRadius: "10px", borderColor: baseTheme.borders.gray }}
            >
                {months.map((month, index) => (
                    <Option key={index + 1} value={index + 1}>
                        {t(`common:${month.toLowerCase()}`)}
                    </Option>
                ))}
            </Dropdown>

            <Dropdown
                placeholder={t("yearUpperCase")}
                showSearch
                value={value?.year ?? undefined}
                onChange={(year) => handleDateChange("year", year)}
                style={{ borderRadius: "10px", borderColor: baseTheme.borders.gray }}
            >
                {years.map((year) => (
                    <Option key={year} value={year}>
                        {year}
                    </Option>
                ))}
            </Dropdown>
        </DateOfBirthContainer>
    );
};

DateOfBirthSelector.propTypes = {
    value: PropTypes.shape({
        day: PropTypes.number,
        month: PropTypes.number,
        year: PropTypes.number,
    }),
    onChange: PropTypes.func,
};

export default DateOfBirthSelector;
